export const SEARCH_TERMS = ["name", "phone", "email"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Name",
    inputType: "text",
  },
  email: {
    type: "string",
    required: true,
    title: "Email",
    inputType: "text",
  },
  phone: {
    type: "string",
    required: true,
    title: "Phone",
    inputType: "text",
  },
  message: {
    type: "text",
    required: true,
    title: "Message",
  },
};
export const initialValues = {
  name: "",
  phone: "",
  email: "",
  message: "",
};

export const view_all_table = [
  { name: "Name", value: "name" },
  { name: "Phone", value: "phone" },
  { name: "Email", value: "email" },
];
